import React from "react";
import "./ContactUsSection.css";

function ContactUs() {
  const GOOGLE_MAPS_API_KEY = "AIzaSyDna72vBFi45ykSWDFiqyPYGaiF3Ul38J4"; // 발급받은 API 키
  const location = "서울특별시 금천구 가산디지털2로 143"; // 원하는 주소나 좌표 입력

  return (
    <section className="contact-section">
      <h2 className="contact-title">찾아오시는 길</h2>

      {/* Google Maps Embed iframe */}
      <div className="map-container">
        <iframe
          title="Google Maps"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          loading="lazy"
          allowFullScreen
          src={`https://www.google.com/maps/embed/v1/place?key=${GOOGLE_MAPS_API_KEY}&q=${encodeURIComponent(location)}`}
        ></iframe>
      </div>

      {/* Contact Information */}
      <div className="contact-info">
        <h3 className="contact-heading">Contact us</h3>
        <p>대표 : 홍성준</p>
        <p>
          E-mail :{" "}
          <a href="mailto:fate_ad@naver.com" className="contact-link">
            fate_ad@naver.com
          </a>
        </p>
        <p>
          주소 : 서울특별시 금천구 가산디지털2로 143 가산어반워크2차 1205호
        </p>
      </div>
    </section>
  );
}

export default ContactUs;
